<form id="busy-form" action="#" method="POST" soho-busyindicator soho-busyindicator
    [transparentOverlay]="transparentOverlay" [blockUI]="true" [text]="message" [displayDelay]="delay" autocomplete="off">
    <div id="notification">
    </div>
    <div class="row" style="padding-top:1%; padding-left:1%;">
        <h2 class="fieldset-title" style="font-size: x-large;">{{ProjectTitle}}</h2>
    </div>
    <div class="row">
        <div class="twelve columns">
            <div class="six columns" style="padding-left: 4%;padding-top: 3%;">
                <div class="row top-padding">
                    <div class="field" id="divstaffid">
                        <label id="tblstaffid" class="required" for="staffid">HMD ID</label>
                        <input id="staffid" name="staffid" type="number" data-validate="required" soho-input placeholder="111000"
                            (click)="RemoveError('staffid')" data-mask [(ngModel)]="model.staffid"  />
                    </div>
                </div>
                <div class="field" id="divsec">
                    <label id="tblsecurityroleid" class="required" for="securityroleid">Access
                        Type</label>
                    <select id="securityroleid" soho-dropdown name="securityroleid"
                        (click)="RemoveError('securityroleid')" [(ngModel)]="model.securityroleid">
                        <option value="-1" selected="">--Select--</option>
                        <option value="10001" selected="">ADMIN</option>
                        <option value="10002" selected="">FINANCE</option>
                    </select>
                </div>
                <div class="field ">
                    <label id="tblemailaddress" class="required" for="emailaddress">User Email Id</label>
                    <input id="emailaddress" name="emailaddress" type="text" data-validate="required"
                        placeholder="someone@someplace.com"data-mask (click)="RemoveError('emailaddress')"
                        [(ngModel)]="model.emailaddress"  />
                </div>
                
            </div>
        </div>
        <div class="row" id="UploadDetails" style="text-align: center;padding-top: 2%;" class=" twelve columns">
            <button class="btn-primary hide-focus" type="button" title="UpdateAcessDetails" (click)="UpdateAcessDetails()">Update Detailes</button>&nbsp;
            <button class="btn-secondary hide-focus" type="button" title="DeactiveUser"(click)="DeactiveUser()">DeactiveUser</button>&nbsp;
            
            <button class="btn-secondary hide-focus" type="button" title="Cancel"(click)="Cancel()">Cancel</button>
        </div>
    </div>
</form>

